import type {Result, UseCase} from 'framework';
import type {AuthRepository} from '../ports/auth.repository';
import type {SignOutError} from '../../domain/errors';

export class SignOut implements UseCase<[], undefined> {
  constructor(private readonly authRepository: AuthRepository) {}

  execute(): Promise<Result<undefined, SignOutError>> {
    return this.authRepository.signOut();
  }
}
